export default __webpack_public_path__ + "static/media/catan.480e2e40.jpeg";